function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-eye {\n        fill: #9e9e9e;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "oDIFsf",
  transform: "translate(0.001 0.008)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_100",
  "data-name": "Trazado 100",
  className: "cls-1-eye",
  d: "M28.426,7.771a21.454,21.454,0,0,1-6.679,5.654,16.313,16.313,0,0,1-6.213,2,14.353,14.353,0,0,1-6.757-.994A20.96,20.96,0,0,1,.125,8.019a.373.373,0,0,1-.033-.527L.125,7.46A20.941,20.941,0,0,1,9.025.967a14.664,14.664,0,0,1,11.852.59,21.151,21.151,0,0,1,7.549,6.135ZM13.98,2.07A12.945,12.945,0,0,0,9.1,3.111,19.5,19.5,0,0,0,2.812,7.522c-.171.171-.155.28,0,.45a19.987,19.987,0,0,0,4.769,3.65,14.07,14.07,0,0,0,5.7,1.771,12.8,12.8,0,0,0,6-.963A19.246,19.246,0,0,0,25.6,8.019c.171-.171.155-.264,0-.435a19.782,19.782,0,0,0-4.8-3.666A13.779,13.779,0,0,0,13.98,2.07Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_101",
  "data-name": "Trazado 101",
  className: "cls-1-eye",
  d: "M10.656,2.25A4.24,4.24,0,1,1,6.4,6.475c0-.113.006-.228.016-.342h0c0-.171,0-.4.124-.5s.28.109.4.186a1.366,1.366,0,0,0,1.817-.575,1.351,1.351,0,0,0-.528-1.833c-.311-.171-.311-.2,0-.4A4.223,4.223,0,0,1,10.656,2.25Z",
  transform: "translate(3.542 1.249)"
}));

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.427,
    height: 15.5,
    viewBox: "0 0 28.427 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c66e4e6.svg";
export { ForwardRef as ReactComponent };